import { render, staticRenderFns } from "./FormatoReceta.vue?vue&type=template&id=9e366938&scoped=true&"
import script from "./FormatoReceta.vue?vue&type=script&lang=js&"
export * from "./FormatoReceta.vue?vue&type=script&lang=js&"
import style0 from "./FormatoReceta.vue?vue&type=style&index=0&id=9e366938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e366938",
  null
  
)

export default component.exports